'use strict';

import {waitForDependencies, newVueComponent} from '../../_imports/utils/utils.common';
import  initNonVueComponents from './_imports/initNonVueComponents';
import initLazyLoad from "../../../components/lazyLoad.js";

const componentName = 'resource-page';

const pageLayout  = document.querySelector('[data-resource-page-layout]');

const isNotVueResource = () => {
	return pageLayout.dataset.resourcePageLayout === 'video-v2';
};

waitForDependencies(() => {
	newVueComponent(componentName, () => require('./_imports/resource-page.vue').default);

	/*
	* Fix vue.js b-lazy initialization issue
 	*/
	setTimeout(() => {
		initLazyLoad({
			isInitFromVueComponent: true,
			componentName
		});
	}, 0);

	if (isNotVueResource()) {	
		initNonVueComponents();
	} 
});